import Vue from 'vue'
import Router from 'vue-router'
import Map from '@/components/Map'
import MapParams from '@/components/MapParams'
import Upload from '@/components/Upload'
import Pluto from '@/components/Pluto'
import Login_layout from '@/components/autenticacion/layout'
import Home from '@/components/home.vue'
import store from '@/store/store.js'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/map',
      name: 'Map',
      component: Map,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/mapparams',
      name: 'MapParams',
      component: MapParams,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/upload',
      name: 'Upload',
      component: Upload,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/va',
      name: 'Pluto',
      component: Pluto,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login_layout
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('login')
  } else {
    next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js